import { useUsers } from './use-users';
import { useRoles } from './use-roles';

interface DashboardStats {
  totalUsers: number;
  activeUsers: number;
  totalRoles: number;
  isLoading: boolean;
  error: Error | null;
}

export const useDashboardStats = (): DashboardStats => {
  // Fetch users with no pagination to get total count
  const { 
    data: usersData, 
    isLoading: usersLoading, 
    error: usersError 
  } = useUsers({ page: 1, size: 1 }); // Minimal fetch for count

  // Fetch roles with no pagination to get total count
  const { 
    data: rolesData, 
    isLoading: rolesLoading, 
    error: rolesError 
  } = useRoles({ page: 1, size: 1 }); // Minimal fetch for count

  // Calculate active users from the total users data
  // Note: We would need a separate API endpoint for active users count in a real scenario
  // For now, we'll use the total count as a placeholder
  const activeUsers = usersData?.total || 0;

  return {
    totalUsers: usersData?.total || 0,
    activeUsers,
    totalRoles: rolesData?.total || 0,
    isLoading: usersLoading || rolesLoading,
    error: (usersError as Error | null) || (rolesError as Error | null) || null,
  };
};